import React from 'react';
import useDataGrid from '@afosto/utils-react/datagrid/useDataGrid';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useOrderContext } from '../../../../components/OrderProvider';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Hidden from '@material-ui/core/Hidden';
import DataGrid from '@afosto/app-components-react/DataGrid';
import DataList from '@afosto/app-components-react/DataList';
import AcceptanceListItem from '../../../../components/AcceptanceListItem';
import { calculationFormatter, prepaidFormatter, transactionFormatter } from './formatters';
import translations from './translations';

const AcceptancesSection = () => {
  const intl = useIntl();
  const { order } = useOrderContext();
  const dataSource = useDataGrid(order?.acceptances ?? [], {
    modules: ['dataProperties'],
    dataProperties: {
      fixedProperties: [
        {
          key: 'amount',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.amount',
            defaultMessage: 'Amount',
            description: 'The column name for column amount',
          }),
          type: 'currency',
        },
        {
          key: 'is_paid',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.isPaid',
            defaultMessage: 'Paid',
            description: 'The column name for column is paid',
          }),
          type: 'boolean',
        },
        {
          key: 'is_prepaid',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.payment',
            defaultMessage: 'Payment',
            description: 'The column name for column payment',
          }),
          type: 'prepaid',
        },
        {
          key: 'is_settlement',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.isSettlement',
            defaultMessage: 'Settlement',
            description: 'The column name for column is settlement',
          }),
          type: 'boolean',
        },
        {
          key: 'calculation_id',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.calculation',
            defaultMessage: 'Calculation',
            description: 'The column name for column calculation',
          }),
          type: 'calculation',
        },
        {
          key: 'transaction_secret',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.transaction',
            defaultMessage: 'Transaction',
            description: 'The column name for column transaction',
          }),
          type: 'transaction',
        },
        {
          key: 'accepted_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.acceptedAt',
            defaultMessage: 'Accepted at',
            description: 'The column name for column accepted at',
          }),
          type: 'datetime',
        },
        {
          key: 'created_at',
          name: intl.formatMessage({
            id: 'dataGrid.columns.acceptances.createdAt',
            defaultMessage: 'Created at',
            description: 'The column name for column created at',
          }),
          type: 'datetime',
        },
      ],
    },
  });

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Hidden implementation="js" mdUp>
        <DataList
          dataSource={dataSource}
          renderItem={acceptance => (
            <AcceptanceListItem acceptance={acceptance} key={acceptance.id} />
          )}
        />
      </Hidden>
      <Hidden implementation="js" smDown>
        <DataGrid
          dataSource={dataSource}
          formatters={{
            calculation: calculationFormatter,
            prepaid: prepaidFormatter,
            transaction: transactionFormatter,
          }}
        />
      </Hidden>
    </Card>
  );
};

export default AcceptancesSection;
